import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { JobService } from 'app/jobService';
import { Router } from '@angular/router';

@Component({
  selector: 'apply-job-section6',
  templateUrl: './apply-job-section6.component.html',
  styleUrls: ['./apply-job-section6.component.scss']
})
export class ApplyJobSection6Component implements OnInit {

  userForm: any;

  constructor(private formBuilder: FormBuilder, private js: JobService, private router: Router) { }

  ngOnInit() {
    // this.SentMailToApplicant();
    // this.SentMailToHumanResource();

    this.js.navigate = 6;
    this.userForm = this.formBuilder.group({

    });
  }

  Finish(){     
    this.js.ClearData();
    this.router.navigateByUrl('applyjobsection1?announce=' + this.js.announce + '&position=' + this.js.position);
  }

  SentMailToApplicant(){
    this.js.SentMailToApplicant().subscribe(
      (applyJobID) => {
        if (Number(applyJobID) != 0) {
          //ส่งสำเร็จ
        } else {
          //ส่งไม่สำเร็จ
        }
      },
      (error) => { alert(JSON.stringify(error)) },
      () => {

      }
    );
  }

  SentMailToHumanResource(){
    this.js.SentMailToHumanResource().subscribe(
      (applyJobID) => {
        if (Number(applyJobID) != 0) {
          //ส่งสำเร็จ
        } else {
          //ส่งไม่สำเร็จ
        }
      },
      (error) => { alert(JSON.stringify(error)) },
      () => {

      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/apply-job-section6/apply-job-section6.component.ts